import { render, staticRenderFns } from "./FiBuBuchungsvorlage.vue?vue&type=template&id=4666c9e0&scoped=true&"
import script from "./FiBuBuchungsvorlage.vue?vue&type=script&lang=js&"
export * from "./FiBuBuchungsvorlage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666c9e0",
  null
  
)

export default component.exports